import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=7bff3dc0"
import script from "./Light.vue?vue&type=script&lang=js"
export * from "./Light.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports